"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/web.dom-collections.iterator.js");
var _react = _interopRequireDefault(require("react"));
var _prismjs = _interopRequireDefault(require("prismjs"));
var _Icons = _interopRequireDefault(require("../Icons"));
require("prismjs/components/prism-go");
require("prismjs/components/prism-python");
require("prismjs/components/prism-ruby");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
// import 'prismjs/themes/prism.css';
// import 'prismjs/components/prism-markup';
// import 'prismjs/components/prism-jsx';
// import 'prismjs/components/prism-javascript';
// import 'prismjs/plugins/line-numbers/prism-line-numbers.js'
// import 'prismjs/plugins/line-numbers/prism-line-numbers.css'
// import 'prismjs/components/prism-php';
const CodeBlock = _ref => {
  let {
    code,
    language,
    title
  } = _ref;
  const [copied, setCopied] = _react.default.useState(false);
  _react.default.useEffect(() => _prismjs.default.highlightAll(), []);
  const copy = () => {
    navigator.clipboard.writeText(code);
    setCopied(true);
    setTimeout(() => {
      setCopied(false);
    }, 2500);
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "hpd-code-block"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "hpd-code-block-header bg-gradient"
  }, /*#__PURE__*/_react.default.createElement("div", null, title || 'Code'), /*#__PURE__*/_react.default.createElement("div", {
    className: "flex color-text-secondary hpd-icon-button hoverable",
    onClick: copy
  }, copied ? /*#__PURE__*/_react.default.createElement(_Icons.default, {
    name: "check",
    width: "15px",
    height: "15px"
  }) : /*#__PURE__*/_react.default.createElement(_Icons.default, {
    name: "copy",
    width: "13px",
    height: "13px"
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: "hpd-code-block-body"
  }, /*#__PURE__*/_react.default.createElement("pre", {
    className: "line-numbers"
  }, /*#__PURE__*/_react.default.createElement("code", {
    className: "language-".concat(language)
  }, code))));
};
var _default = exports.default = CodeBlock;